module.exports = __webpack_public_path__ + "static/img/dress_left.79dd11e7.png";